import { useIsAnyMobileState } from '@/stores/responsive.store';
import { memo } from 'react';
import useDuplicateTicket from './use-duplicate-ticket-modal';
import { Modal } from '@/components/_ui/modal';
import DesktopDuplicateTicketForm from './desktop-duplicate-ticket-form';
import MobileDuplicateTicketForm from './mobile-duplicate-ticket-form';
import { Spinner } from '@/components/_ui/spinner';
import TimeFrameModal from '@/components/ui/timeframe-modal';

export type TDuplicateTicketModalType = 'DuplicateTicketModal';
export interface IDuplicateTicketModalProps {
  spaceId: string;
  ticketId: string;
}

const DuplicateTicketModal = memo(({ spaceId, ticketId }: IDuplicateTicketModalProps) => {
  const isAnyMobile = useIsAnyMobileState();
  const duplicateTicketModalHookState = useDuplicateTicket({ spaceId, ticketId });

  if (duplicateTicketModalHookState.isLoadingSingleTicketQuery) {
    return (
      <Modal
        className={
          isAnyMobile ? 'p-0 w-[365px] h-fit overflow-hidden' : 'p-0 max-w-[1080px] w-full h-fit overflow-hidden'
        }
        isCloseOutside={false}
        isButtonClose={true}
        isOpen={duplicateTicketModalHookState.isDuplicateTicketOpen}
        onClose={duplicateTicketModalHookState.handleCloseModal}
        lockBodyScroll
      >
        <div className={isAnyMobile ? 'h-[450px]' : 'h-[600px]'}>
          <div className="flex items-center justify-center w-full h-full">
            <Spinner className="w-[36px] h-[36px]" />
          </div>
        </div>
      </Modal>
    );
  }

  if (isAnyMobile) {
    return (
      <>
        <Modal
          className="p-0 w-[365px] h-fit overflow-hidden"
          closeButtonClassName="top-[12px] right-[12px]"
          isCloseOutside={false}
          isButtonClose={true}
          isOpen={duplicateTicketModalHookState.isDuplicateTicketOpen}
          onClose={duplicateTicketModalHookState.handleCloseModal}
          lockBodyScroll
        >
          <MobileDuplicateTicketForm {...duplicateTicketModalHookState} />
        </Modal>
        <TimeFrameModal
          submitText="Apply Date"
          title="Set Due date"
          initialDateRange={duplicateTicketModalHookState.dateValues ?? undefined}
          isOpen={duplicateTicketModalHookState.isOpenDateModal}
          onClose={() => {
            duplicateTicketModalHookState.handleCloseDateModal();
          }}
          onApply={(dateRange) => {
            duplicateTicketModalHookState.form.setValue('startDate', dateRange?.from?.toISOString());
            duplicateTicketModalHookState.form.setValue('endDate', dateRange?.to?.toISOString());
            duplicateTicketModalHookState.handleSetDateValuesModal(dateRange);
            duplicateTicketModalHookState.handleCloseDateModal();
          }}
        />
      </>
    );
  }

  return (
    <>
      <Modal
        className="p-0 max-w-[1080px] w-full h-fit overflow-hidden gap-0"
        isCloseOutside={false}
        isButtonClose={true}
        isOpen={duplicateTicketModalHookState.isDuplicateTicketOpen}
        onClose={duplicateTicketModalHookState.handleCloseModal}
        closeButtonClassName="top-[12px] right-[12px]"
        lockBodyScroll
      >
        <DesktopDuplicateTicketForm {...duplicateTicketModalHookState} />
      </Modal>
      <TimeFrameModal
        submitText="Apply Date"
        title="Set Due date"
        initialDateRange={duplicateTicketModalHookState.dateValues ?? undefined}
        isOpen={duplicateTicketModalHookState.isOpenDateModal}
        onClose={() => {
          duplicateTicketModalHookState.handleCloseDateModal();
        }}
        onApply={(dateRange) => {
          duplicateTicketModalHookState.form.setValue('startDate', dateRange?.from?.toISOString());
          duplicateTicketModalHookState.form.setValue('endDate', dateRange?.to?.toISOString());
          duplicateTicketModalHookState.handleSetDateValuesModal(dateRange);
          duplicateTicketModalHookState.handleCloseDateModal();
        }}
      />
    </>
  );
});

DuplicateTicketModal.displayName = 'DuplicateTicketModal';
export default DuplicateTicketModal;
